// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.banner-section{
  margin-top: 80px;
}
.bg-about{
    background-color: #0EC6FB;
    padding: 1rem 0;
}
.sub-head{
    font-size: 85px;
}
.us{
    position: relative;
    left: 10px;
    bottom: 60px;
    font-size: 60px;
}
.follow{
    position: absolute;
    left: 30%;
    bottom: -50px;
    padding: 10px 20px;
    background-color: #FFA901;
    border-radius: 20px;
}
.follow-text{
    font-size: 26px;
    color: #000;
}
p{
    font-size: 16px;
    font-weight: 500;
}
b{
    font-weight: 800;
}
.studs{
    background-image: linear-gradient(180deg, white 50%, #F4FBFF 50%);
    /* height: 55vh; */
    /* background-color: #F4FBFF; */
    /* padding-bottom: 10vh; */
    overflow: hidden;
    width: 100%;
}
.studs .para{
    padding-left: 3rem;
    padding-right: 3rem;
}
.studs .para p:nth-child(1){
    padding-top: 3rem;
}
.studs .para p:nth-child(2){
    padding-top: 3rem;
}
.student-img img{
    box-shadow: -170px -200px 0px -130px #E2E2E2;
    width: 90%;
}

.pay-journey{
    color: #000000;
    font-weight: 800;
    font-size: 28px;
}
.pay-text{
    position: relative;
    left: 40px;
    font-size: 16px;
    font-weight: 500;
}
.w-65{
    width: 65%;
}
.user-img{
    background-image: linear-gradient(220deg, transparent 50%, #F4FBFF 50%);
}
.user h4::before{
    content: "";
    position: absolute;
    height: 0;
    border-bottom: 1px solid #707070;
    top: 0;
    left: 0;
    width: 75px;
}
.user h4{
    border-bottom: 1px solid #707070; 
    border-left: 1px solid #707070; 
}
.user h4 , .user p{
    padding-right: 120px !important;
}
.mission p {
    padding-left: 120px !important;
    padding-right: 24px;
}
.mission-text{
    background-color: #0EC6FB;
    padding: 4rem 0;
    margin-top: 4rem;
}
.mission .heads{
    font-size: 48px;
}
.mission .sub-head{
    font-size: 60px;
}
.mission-block , .stud-block , .pay-block , .about-block{
    padding: 3rem;
}
.mission-text::after{
    content: " ";
    position: absolute;
    z-index: -1;
    top: -12%;
    left: -8%;
    height: 160px;
    border-radius: 18px;
    border-left: 160px solid #E2E2E2;

}
.value{
    margin-top: 3rem;
    margin-bottom: 2rem;
}
.value-text{
    padding-left: 120px !important;
}
.value .sub-head{
    font-size: 64px;
}
.value h5{
    font-weight: 600;
}
.icon i{
    margin: 2px 4px;
    border: 2px solid #000;
    padding: 6px 8px;
    border-radius: 10px;
    color: black;
}
.icon i:hover{
    color: white;
    border: 1px solid #16c6fb;
    transform: scale(1.1);
}
@media screen and (max-width:768px){
     .heads{
        font-size: 36px;
    }
    .sub-head{
        font-size: 44px;
    }
    .studs .para{
        padding-left: 2px;
        padding-right: 2px;
    }
    .studs .para p:nth-child(1),.studs .para p:nth-child(2){
        padding-top: 1rem;
    }
    .student-img img{
        width: 100%;
        box-shadow: none;
    }
    .pay-journey{
        font-size: 22px;
    }
    .pay-text{
        left: 0;
        padding-bottom: 24px;
    }
    .user h4 , .user p{
        padding-right: 2px !important;
    }
    .mission p , .value-text {
        padding: 12px 16px !important;
    }
    .mission-text{
        margin-top: 3rem;
        padding: 2px 16px !important;
    }
    .mission-block , .stud-block , .pay-block , .about-block{
        padding: 1rem;
    }
    .mission .heads{
        font-size: 36px;
    }
    .mission .sub-head{
        font-size: 44px;
    }
    .mission-text::after {
        height: 0px;
    }
    .value{
        margin-top: .5rem;
    }
}`, "",{"version":3,"sources":["webpack://./src/app/about/about.component.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;AACA;IACI,yBAAyB;IACzB,eAAe;AACnB;AACA;IACI,eAAe;AACnB;AACA;IACI,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,eAAe;AACnB;AACA;IACI,kBAAkB;IAClB,SAAS;IACT,aAAa;IACb,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;AACvB;AACA;IACI,eAAe;IACf,WAAW;AACf;AACA;IACI,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,iEAAiE;IACjE,kBAAkB;IAClB,+BAA+B;IAC/B,0BAA0B;IAC1B,gBAAgB;IAChB,WAAW;AACf;AACA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,4CAA4C;IAC5C,UAAU;AACd;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,kBAAkB;IAClB,UAAU;IACV,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,UAAU;AACd;AACA;IACI,uEAAuE;AAC3E;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,gCAAgC;IAChC,MAAM;IACN,OAAO;IACP,WAAW;AACf;AACA;IACI,gCAAgC;IAChC,8BAA8B;AAClC;AACA;IACI,+BAA+B;AACnC;AACA;IACI,8BAA8B;IAC9B,mBAAmB;AACvB;AACA;IACI,yBAAyB;IACzB,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,eAAe;AACnB;AACA;IACI,eAAe;AACnB;AACA;IACI,aAAa;AACjB;AACA;IACI,YAAY;IACZ,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,SAAS;IACT,aAAa;IACb,mBAAmB;IACnB,gCAAgC;;AAEpC;AACA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;AACA;IACI,8BAA8B;AAClC;AACA;IACI,eAAe;AACnB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,sBAAsB;IACtB,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;AAChB;AACA;IACI,YAAY;IACZ,yBAAyB;IACzB,qBAAqB;AACzB;AACA;KACK;QACG,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,iBAAiB;QACjB,kBAAkB;IACtB;IACA;QACI,iBAAiB;IACrB;IACA;QACI,WAAW;QACX,gBAAgB;IACpB;IACA;QACI,eAAe;IACnB;IACA;QACI,OAAO;QACP,oBAAoB;IACxB;IACA;QACI,6BAA6B;IACjC;IACA;QACI,6BAA6B;IACjC;IACA;QACI,gBAAgB;QAChB,4BAA4B;IAChC;IACA;QACI,aAAa;IACjB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,WAAW;IACf;IACA;QACI,iBAAiB;IACrB;AACJ","sourcesContent":[".banner-section{\n  margin-top: 80px;\n}\n.bg-about{\n    background-color: #0EC6FB;\n    padding: 1rem 0;\n}\n.sub-head{\n    font-size: 85px;\n}\n.us{\n    position: relative;\n    left: 10px;\n    bottom: 60px;\n    font-size: 60px;\n}\n.follow{\n    position: absolute;\n    left: 30%;\n    bottom: -50px;\n    padding: 10px 20px;\n    background-color: #FFA901;\n    border-radius: 20px;\n}\n.follow-text{\n    font-size: 26px;\n    color: #000;\n}\np{\n    font-size: 16px;\n    font-weight: 500;\n}\nb{\n    font-weight: 800;\n}\n.studs{\n    background-image: linear-gradient(180deg, white 50%, #F4FBFF 50%);\n    /* height: 55vh; */\n    /* background-color: #F4FBFF; */\n    /* padding-bottom: 10vh; */\n    overflow: hidden;\n    width: 100%;\n}\n.studs .para{\n    padding-left: 3rem;\n    padding-right: 3rem;\n}\n.studs .para p:nth-child(1){\n    padding-top: 3rem;\n}\n.studs .para p:nth-child(2){\n    padding-top: 3rem;\n}\n.student-img img{\n    box-shadow: -170px -200px 0px -130px #E2E2E2;\n    width: 90%;\n}\n\n.pay-journey{\n    color: #000000;\n    font-weight: 800;\n    font-size: 28px;\n}\n.pay-text{\n    position: relative;\n    left: 40px;\n    font-size: 16px;\n    font-weight: 500;\n}\n.w-65{\n    width: 65%;\n}\n.user-img{\n    background-image: linear-gradient(220deg, transparent 50%, #F4FBFF 50%);\n}\n.user h4::before{\n    content: \"\";\n    position: absolute;\n    height: 0;\n    border-bottom: 1px solid #707070;\n    top: 0;\n    left: 0;\n    width: 75px;\n}\n.user h4{\n    border-bottom: 1px solid #707070; \n    border-left: 1px solid #707070; \n}\n.user h4 , .user p{\n    padding-right: 120px !important;\n}\n.mission p {\n    padding-left: 120px !important;\n    padding-right: 24px;\n}\n.mission-text{\n    background-color: #0EC6FB;\n    padding: 4rem 0;\n    margin-top: 4rem;\n}\n.mission .heads{\n    font-size: 48px;\n}\n.mission .sub-head{\n    font-size: 60px;\n}\n.mission-block , .stud-block , .pay-block , .about-block{\n    padding: 3rem;\n}\n.mission-text::after{\n    content: \" \";\n    position: absolute;\n    z-index: -1;\n    top: -12%;\n    left: -8%;\n    height: 160px;\n    border-radius: 18px;\n    border-left: 160px solid #E2E2E2;\n\n}\n.value{\n    margin-top: 3rem;\n    margin-bottom: 2rem;\n}\n.value-text{\n    padding-left: 120px !important;\n}\n.value .sub-head{\n    font-size: 64px;\n}\n.value h5{\n    font-weight: 600;\n}\n.icon i{\n    margin: 2px 4px;\n    border: 2px solid #000;\n    padding: 6px 8px;\n    border-radius: 10px;\n    color: black;\n}\n.icon i:hover{\n    color: white;\n    border: 1px solid #16c6fb;\n    transform: scale(1.1);\n}\n@media screen and (max-width:768px){\n     .heads{\n        font-size: 36px;\n    }\n    .sub-head{\n        font-size: 44px;\n    }\n    .studs .para{\n        padding-left: 2px;\n        padding-right: 2px;\n    }\n    .studs .para p:nth-child(1),.studs .para p:nth-child(2){\n        padding-top: 1rem;\n    }\n    .student-img img{\n        width: 100%;\n        box-shadow: none;\n    }\n    .pay-journey{\n        font-size: 22px;\n    }\n    .pay-text{\n        left: 0;\n        padding-bottom: 24px;\n    }\n    .user h4 , .user p{\n        padding-right: 2px !important;\n    }\n    .mission p , .value-text {\n        padding: 12px 16px !important;\n    }\n    .mission-text{\n        margin-top: 3rem;\n        padding: 2px 16px !important;\n    }\n    .mission-block , .stud-block , .pay-block , .about-block{\n        padding: 1rem;\n    }\n    .mission .heads{\n        font-size: 36px;\n    }\n    .mission .sub-head{\n        font-size: 44px;\n    }\n    .mission-text::after {\n        height: 0px;\n    }\n    .value{\n        margin-top: .5rem;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
